var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviouslyPreferred = function SvgPreviouslyPreferred(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.058 5.01 6.222-2.852c.453-.21.987-.21 1.44 0l6.222 2.852c.64.293 1.058.953 1.058 1.678v4.31c0 5.088-3.413 9.847-8 11.002-4.587-1.155-8-5.914-8-11.003v-4.31c0-.724.418-1.384 1.058-1.677m2.656 5.813a.87.87 0 0 0-.857.883.87.87 0 0 0 .857.882h8.572a.87.87 0 0 0 .857-.882.87.87 0 0 0-.857-.883z",
    clipRule: "evenodd"
  })));
};
export default SvgPreviouslyPreferred;